/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFinancials = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14.414 2 21 8.586v13.422H3V2.01zm-.828 2L5 4.009v16h14V9.415zM9 14v4H7v-4zm8-2v6h-2v-6zm-4-4v10h-2V8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFinancials as Financials };
